<template>
  <div>
    <div class="parcel-info">
      <div>
        <label
          for=""
          class="font-c999"
        >{{TLang('配送方式','my')}}</label>
        <span class="font-c111">{{ deliveryInfo.deliveryWayName }}</span>
      </div>
      <div class="mt-8">
        <div class="dib">
          <label
            for=""
            class="font-c999"
          >{{TLang('快递编号','my')}}</label>
          <span class="font-c111">{{ deliveryInfo.expressOrderNo }}</span>
        </div>
        <div class="dib ml-32">
          <label
            for=""
            class="font-c999"
          >{{TLang('物流公司','my')}}</label>
          <span class="font-c111">{{ deliveryInfo.expressCompany }}</span>
        </div>
      </div>
    </div>
    <div class="track-info mt-24">
      <div
        v-for="(traceItem, index) in tracks"
        :key="index"
        class="track-item"
        :class="{ 'font-c999': index, 'mt-20': index && traceItem.spaceFlag }"
      >
        <span :class="!index ? 'icon-location' : 'icon'"></span>
        <span
          v-if="!index || traceItem.spaceFlag"
          style="width: 176px; display: inline-block;"
        >{{
          traceItem.date +
            "&nbsp;" +
            traceItem.weekDay +
            "&nbsp;" +
            traceItem.time
        }}</span>
        <span
          v-else
          style="width: 176px; display: inline-block;"
        >{{
          traceItem.time
        }}</span>
        <span class="ml-40">{{ traceItem.content }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParcelItem',
  props: {
    tracks: Array,
    deliveryInfo: Object,
  },
  data() {
    return {
      parcelInfo: 'parcel infomation',
      trackInfo: 'track information',
    };
  },
  updated() {
    console.log(this.tracks, 'tracks');
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.parcel-info {
  padding-bottom: 16px;
  border-bottom: solid 1px #e5e5e5;
}
.track-info {
  .track-item {
    margin-bottom: 12px;
    &:last-of-type {
      margin-bottom: 0;
    }
    .icon-location {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: url("~@assets/images/logistics/location.png");
      background-size: 24px 24px;
      margin-left: -6px;
      vertical-align: middle;
    }
    .icon {
      display: inline-block;
      width: 7px;
      height: 7px;
      vertical-align: middle;
      border: 3px solid rgba(229, 229, 229, 1);
      border-radius: 7px;
      background-color: #fff;
      margin-right: 4px;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        bottom: 7px;
        left: 3px;
        width: 1px;
        height: 24px;
        background-color: #e5e5e5;
      }
    }
  }
}
</style>
